import { RouterModule, Routes } from '@angular/router';

import { GuardService } from './services/guard.service';

import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { LoginPageComponent } from './authentication/login-page/login-page.component';

// Menu : Company
import { ViewCompanyComponent } from './companies/view-company/view-company.component';
import { UpdateCompanyComponent } from './companies/update-company/update-company.component'

// Menu : Catalogs
import { CreateDepartmentComponent } from './departments/create-department/create-department.component';
import { ReadDepartmentComponent } from './departments/read-department/read-department.component';
import { UpdateDepartmentComponent } from './departments/update-department/update-department.component';
import { DisplayDepartmentComponent } from './departments/display-department/display-department.component';
import { CreateEmployeeComponent } from './employees/create-employee/create-employee.component';
import { ReadEmployeeComponent } from './employees/read-employee/read-employee.component';
import { UpdateEmployeeComponent } from './employees/update-employee/update-employee.component';
import { DisplayEmployeeComponent } from './employees/display-employee/display-employee.component';
import { RolesjobsComponent } from './rolesjobs/rolesjobs/rolesjobs.component';
import { CreateJobComponent } from './rolesjobs/create-job/create-job.component';
import { ReadJobComponent } from './rolesjobs/read-job/read-job.component';
import { UpdateJobComponent } from './rolesjobs/update-job/update-job.component';
import { DisplayJobComponent } from './rolesjobs/display-job/display-job.component';
import { CreateRoleComponent } from './rolesjobs/create-role/create-role.component';
import { ReadRoleComponent } from './rolesjobs/read-role/read-role.component';
import { UpdateRoleComponent } from './rolesjobs/update-role/update-role.component';
import { DisplayRoleComponent } from './rolesjobs/display-role/display-role.component';
import { CreateActivityComponent } from './activities/create-activity/create-activity.component';
import { ReadActivityComponent } from './activities/read-activity/read-activity.component';
import { UpdateActivityComponent } from './activities/update-activity/update-activity.component';
import { DisplayActivityComponent } from './activities/display-activity/display-activity.component';
import { CreateActivityClassificationComponent } from './activity-classification/create-activity-classification/create-activity-classification.component';
import { ReadActivityClassificationComponent } from './activity-classification/read-activity-classification/read-activity-classification.component';
import { UpdateActivityClassificationComponent } from './activity-classification/update-activity-classification/update-activity-classification.component';
import { CreateWorkShiftComponent } from './work-shifts/create-work-shift/create-work-shift.component';
import { ReadWorkShiftComponent } from './work-shifts/read-work-shift/read-work-shift.component';
import { UpdateWorkShiftComponent } from './work-shifts/update-work-shift/update-work-shift.component';
import { DisplayWorkShiftComponent } from './work-shifts/display-work-shift/display-work-shift.component';
import { CreateGroupComponent } from './groups/create-group/create-group.component';
import { ReadGroupComponent } from './groups/read-group/read-group.component';
import { UpdateGroupComponent } from './groups/update-group/update-group.component';
import { DisplayGroupComponent } from './groups/display-group/display-group.component';
import { CreateUserComponent } from './users/create-user/create-user.component';
import { ReadUserComponent } from './users/read-user/read-user.component';
import { UpdateUserComponent } from './users/update-user/update-user.component';
import { DisplayUserComponent } from './users/display-user/display-user.component';
import { DisplayPermissionComponent } from './permissions/display-permission/display-permission.component';
import { SpecialPermissionsComponent } from './permissions/special-permissions/special-permissions.component';
import { SettingsComponent } from './catalogs/settings/settings.component';

// Menu : Payroll
import { CreateCheckClockComponent } from './check-clock/create-check-clock/create-check-clock.component';
import { ReadCheckClockComponent } from './check-clock/read-check-clock/read-check-clock.component';
import { DisplayCheckClockComponent } from './check-clock/display-check-clock/display-check-clock.component';
import { ReadRegisteredEmployeesComponent } from './check-clock/read-registered-employees/read-registered-employees.component';
import { CreateUnregisteredEmployeeComponent } from './check-clock/create-unregistered-employee/create-unregistered-employee.component';
import { ReadUnregisteredEmployeesComponent } from './check-clock/read-unregistered-employees/read-unregistered-employees.component';
import { CreateSupervisorReportComponent } from './supervisor-reports/create-supervisor-report/create-supervisor-report.component';
import { ReadSupervisorReportComponent } from './supervisor-reports/read-supervisor-report/read-supervisor-report.component';
import { UpdateSupervisorReportComponent } from './supervisor-reports/update-supervisor-report/update-supervisor-report.component';
import { DisplaySupervisorReportComponent } from './supervisor-reports/display-supervisor-report/display-supervisor-report.component';
import { CreateCarrierReportComponent } from './carrier-reports/create-carrier-report/create-carrier-report.component';
import { ReadCarrierReportComponent } from './carrier-reports/read-carrier-report/read-carrier-report.component';
import { UpdateCarrierReportComponent } from './carrier-reports/update-carrier-report/update-carrier-report.component';
import { DisplayCarrierReportComponent } from './carrier-reports/display-carrier-report/display-carrier-report.component';
import { CreatePrompterReportComponent } from './prompter-reports/create-prompter-report/create-prompter-report.component';
import { ReadPrompterReportComponent } from './prompter-reports/read-prompter-report/read-prompter-report.component';
import { UpdatePrompterReportComponent } from './prompter-reports/update-prompter-report/update-prompter-report.component';
import { DisplayPrompterReportComponent } from './prompter-reports/display-prompter-report/display-prompter-report.component';
import { CreateSecurityReportComponent } from './security-report/create-security-report/create-security-report.component';
import { ReadSecurityReportComponent } from './security-report/read-security-report/read-security-report.component';
import { UpdateSecurityReportComponent } from './security-report/update-security-report/update-security-report.component';
import { DisplaySecurityReportComponent } from './security-report/display-security-report/display-security-report.component';
import { CreateNewPrompterReportComponent } from './new-prompter-report/create-new-prompter-report/create-new-prompter-report.component';
import { ReadNewPrompterReportComponent } from './new-prompter-report/read-new-prompter-report/read-new-prompter-report.component';
import { UpdateNewPrompterReportComponent } from './new-prompter-report/update-new-prompter-report/update-new-prompter-report.component';
import { DisplayNewPrompterReportComponent } from './new-prompter-report/display-new-prompter-report/display-new-prompter-report.component';
import { CreateOvertimeComponent } from './overtimes/create-overtime/create-overtime.component';
import { ReadOvertimeComponent } from './overtimes/read-overtime/read-overtime.component';
import { UpdateOvertimeComponent } from './overtimes/update-overtime/update-overtime.component';
import { DisplayOvertimeComponent } from './overtimes/display-overtime/display-overtime.component';
import { DisplayAssistanceReportComponent } from './assistance-report/display-assistance-report/display-assistance-report.component';
import { DisplayAssistanceComponent } from './assistance/display-assistance/display-assistance.component';
import { DisplayPayrollEstimateComponent } from './payroll-estimate/display-payroll-estimate/display-payroll-estimate.component';
import { CreateLoanComponent } from './loans/create-loan/create-loan.component';
import { ReadLoanComponent } from './loans/read-loan/read-loan.component';
import { UpdateLoanComponent } from './loans/update-loan/update-loan.component';
import { DisplayLoanComponent } from './loans/display-loan/display-loan.component';

// Menu : Sales
import { CreateCustomerComponent } from './customers/create-customer/create-customer.component';
import { ReadCustomerComponent } from './customers/read-customer/read-customer.component';
import { UpdateCustomerComponent } from './customers/update-customer/update-customer.component';
import { DisplayCustomerComponent } from './customers/display-customer/display-customer.component';

import { CreateAddressComponent } from './addresses/create-address/create-address.component';
import { ReadAddressComponent } from './addresses/read-address/read-address.component';
import { UpdateAddressComponent } from './addresses/update-address/update-address.component';
import { DisplayAddressComponent } from './addresses/display-address/display-address.component';

import { CreateFiscalDataComponent } from './fiscal-data/create-fiscal-data/create-fiscal-data.component';
import { ReadFiscalDataComponent } from './fiscal-data/read-fiscal-data/read-fiscal-data.component';
import { UpdateFiscalDataComponent } from './fiscal-data/update-fiscal-data/update-fiscal-data.component';
import { DisplayFiscalDataComponent } from './fiscal-data/display-fiscal-data/display-fiscal-data.component';

import { CreateKeyPersonsComponent } from './key-persons/create-key-persons/create-key-persons.component';
import { ReadKeyPersonsComponent } from './key-persons/read-key-persons/read-key-persons.component';
import { UpdateKeyPersonsComponent } from './key-persons/update-key-persons/update-key-persons.component';
import { DisplayKeyPersonsComponent } from './key-persons/display-key-persons/display-key-persons.component';

// Menu : Purchases
import { CreateSupplierComponent } from './suppliers/create-supplier/create-supplier.component';
import { ReadSupplierComponent } from './suppliers/read-supplier/read-supplier.component';
import { UpdateSupplierComponent } from './suppliers/update-supplier/update-supplier.component';
import { DisplaySupplierComponent } from './suppliers/display-supplier/display-supplier.component';

// Menu : Production
import { CreateProductionOrderComponent } from './production-order/create-production-order/create-production-order.component';
import { ReadProductionOrderComponent } from './production-order/read-production-order/read-production-order.component';
import { UpdateProductionOrderComponent } from './production-order/update-production-order/update-production-order.component';
import { DisplayProductionOrderComponent } from './production-order/display-production-order/display-production-order.component';
import { OdpPriorityComponent } from './production-order/odp-priority/odp-priority.component';
import { OdpLiteSearchComponent } from './production-order/odp-lite-search/odp-lite-search.component';

// Pending to refactor :::
import { CreateSubsidiaryComponent } from './subsidiaries/create-subsidiary/create-subsidiary.component';
import { ReadSubsidiaryComponent } from './subsidiaries/read-subsidiary/read-subsidiary.component';
import { UpdateSubsidiaryComponent } from './subsidiaries/update-subsidiary/update-subsidiary.component';

// Menu : Ships
import { ReadShipComponent } from './ships/read-ship/read-ship.component';
import { UpdateShipComponent } from './ships/update-ship/update-ship.component';
import { CreateShipComponent } from './ships/create-ship/create-ship.component';

// Menu : Units
import { ReadUnitComponent } from './units/read-unit/read-unit.component';
import { UpdateUnitComponent } from './units/update-unit/update-unit.component';
import { CreateUnitComponent } from './units/create-unit/create-unit.component';

// Menu : Banks
import { ReadBankComponent } from './banks/read-bank/read-bank.component';
import { UpdateBankComponent } from './banks/update-bank/update-bank.component';
import { CreateBankComponent } from './banks/create-bank/create-bank.component';
import { DisplayBankComponent } from './banks/display-bank/display-bank.component';

// Menu : InAndOut
import { ReadInAndOutComponent } from './in-and-out/read-in-and-out/read-in-and-out.component';
import { UpdateInAndOutComponent } from './in-and-out/update-in-and-out/update-in-and-out.component';
import { CreateInAndOutComponent } from './in-and-out/create-in-and-out/create-in-and-out.component';

// Menu : Warehouse
import { ReadWarehouseComponent } from './warehouse/read-warehouse/read-warehouse.component';
import { UpdateWarehouseComponent } from './warehouse/update-warehouse/update-warehouse.component';
import { CreateWarehouseComponent } from './warehouse/create-warehouse/create-warehouse.component';

// Menu : Transactions
import { ReadInTranComponent } from './tran/read-in-tran/read-in-tran.component';
import { ReadOutTranComponent } from './tran/read-out-tran/read-out-tran.component';
import { CreateInTranComponent } from './tran/create-in-tran/create-in-tran.component';
import { CreateOutTranComponent } from './tran/create-out-tran/create-out-tran.component';
import { DisplayTranComponent } from './tran/display-tran/display-tran.component';
import { ReadAllTranComponent } from './tran/read-all-tran/read-all-tran.component';

// Menu : Stock
import { ReadStockPiecesComponent } from './stock/read-stock-pieces/read-stock-pieces.component';
import { StockMinimalComponent } from './stock/stock-minimal/stock-minimal.component';

// Menu : Constant Costs
import { ReadConstantCostsComponent } from './costs/read-constant-costs/read-constant-costs.component';
import { CreateConstantCostsComponent } from './costs/create-constant-costs/create-constant-costs.component';
import { UpdateConstantCostsComponent } from './costs/update-constant-costs/update-constant-costs.component';

// Menu : Product Types/Venta/Compra/Client
import { ReadPrTypeComponent } from './pr-types/read-pr-type/read-pr-type.component';
import { CreatePrTypeComponent } from './pr-types/create-pr-type/create-pr-type.component';
import { UpdatePrTypeComponent } from './pr-types/update-pr-type/update-pr-type.component';
import { CreatePrCTypeComponent } from './pr-c-types/create-pr-c-type/create-pr-c-type.component';
import { ReadPrCTypeComponent } from './pr-c-types/read-pr-c-type/read-pr-c-type.component';
import { UpdatePrCTypeComponent } from './pr-c-types/update-pr-c-type/update-pr-c-type.component';
import { CreatePrVntaComponent } from './pr-vnta/create-pr-vnta/create-pr-vnta.component';
import { ReadPrVntaComponent } from './pr-vnta/read-pr-vnta/read-pr-vnta.component';
import { UpdatePrVntaComponent } from './pr-vnta/update-pr-vnta/update-pr-vnta.component';
import { DisplayPrVntaComponent } from './pr-vnta/display-pr-vnta/display-pr-vnta.component';
import { CreatePrCmpaComponent } from './pr-cmpa/create-pr-cmpa/create-pr-cmpa.component';
import { DisplayPrCmpaComponent } from './pr-cmpa/display-pr-cmpa/display-pr-cmpa.component';
import { ReadPrCmpaComponent } from './pr-cmpa/read-pr-cmpa/read-pr-cmpa.component';
import { UpdatePrCmpaComponent } from './pr-cmpa/update-pr-cmpa/update-pr-cmpa.component';
import { CreatePrClientComponent } from './pr-client/create-pr-client/create-pr-client.component';
import { DisplayPrClientComponent } from './pr-client/display-pr-client/display-pr-client.component';
import { ReadPrClientComponent } from './pr-client/read-pr-client/read-pr-client.component';
import { UpdatePrClientComponent } from './pr-client/update-pr-client/update-pr-client.component';

// Menu : Purchase order
import { CreatePurchaseOrderComponent } from './purchase-order/create-purchase-order/create-purchase-order.component';
import { ReadPurchaseOrderComponent } from './purchase-order/read-purchase-order/read-purchase-order.component';
import { DisplayPurchaseOrderComponent } from './purchase-order/display-purchase-order/display-purchase-order.component';
import { UpdatePurchaseOrderComponent } from './purchase-order/update-purchase-order/update-purchase-order.component';
import { PurchaseReportComponent } from './purchase-order/purchase-report/purchase-report.component';

// Menu : Purchase request
import { CreatePurchaseRequestComponent } from './purchase-request/create-purchase-request/create-purchase-request.component';
import { ReadPurchaseRequestComponent } from './purchase-request/read-purchase-request/read-purchase-request.component';
import { DisplayPurchaseRequestComponent } from './purchase-request/display-purchase-request/display-purchase-request.component';
import { UpdatePurchaseRequestComponent } from './purchase-request/update-purchase-request/update-purchase-request.component';
import { OrderPurchaseRequestComponent } from './purchase-request/order-purchase-request/order-purchase-request.component';

// Menu : Lift Order
import { CreateLiftOrderComponent } from './liftOrders/create-lift-order/create-lift-order.component';
import { ReadLiftOrderComponent } from './liftOrders/read-lift-order/read-lift-order.component';
import { DisplayLiftOrderComponent } from './liftOrders/display-lift-order/display-lift-order.component';
import { UpdateLiftOrderComponent } from './liftOrders/update-lift-order/update-lift-order.component';

// Menu : Remission
import { CreateRemissionComponent } from './remissions/create-remission/create-remission.component';
import { ReadRemissionComponent } from './remissions/read-remission/read-remission.component';
import { DisplayRemissionComponent } from './remissions/display-remission/display-remission.component';
import { UpdateRemissionComponent } from './remissions/update-remission/update-remission.component';

import { CreateQuotComponent } from './quot/create-quot/create-quot.component';
import { UpdateQuotComponent } from './quot/update-quot/update-quot.component';
import { ReadQuotComponent } from './quot/read-quot/read-quot.component';
import { DisplayQuotComponent } from './quot/display-quot/display-quot.component';

// Documents Types
import { DisplayDocumentsTypesComponent } from './documents-types/display-documents-types/display-documents-types.component';
import { CreateDocumentsTypesComponent } from './documents-types/create-documents-types/create-documents-types.component';

// Menu : Supplier/Customer Bills
import { ReadSupplierBillComponent } from './supplierBills/read-supplier-bill/read-supplier-bill.component';
import { UpdateSupplierBillComponent } from './supplierBills/update-supplier-bill/update-supplier-bill.component';
import { CreateSupplierBillComponent } from './supplierBills/create-supplier-bill/create-supplier-bill.component';
import { DisplaySupplierBillComponent } from './supplierBills/display-supplier-bill/display-supplier-bill.component';
import { ReadCustomerBillComponent } from './customerBills/read-customer-bill/read-customer-bill.component';
import { UpdateCustomerBillComponent } from './customerBills/update-customer-bill/update-customer-bill.component';
import { CreateCustomerBillComponent } from './customerBills/create-customer-bill/create-customer-bill.component';
import { DisplayCustomerBillComponent } from './customerBills/display-customer-bill/display-customer-bill.component';
import { BillReportDetailComponent } from './customerBills/bill-report-detail/bill-report-detail.component';

// Menu : Income / Outcome
import { ReadIncomeComponent } from './incomes/read-income/read-income.component';
import { UpdateIncomeComponent } from './incomes/update-income/update-income.component';
import { CreateIncomeComponent } from './incomes/create-income/create-income.component';
import { DisplayIncomeComponent } from './incomes/display-income/display-income.component';
import { ReadOutcomeComponent } from './outcomes/read-outcome/read-outcome.component';
import { UpdateOutcomeComponent } from './outcomes/update-outcome/update-outcome.component';
import { CreateOutcomeComponent } from './outcomes/create-outcome/create-outcome.component';
import { DisplayOutcomeComponent } from './outcomes/display-outcome/display-outcome.component';

// Menu : Suaje
import { CreateSuajeComponent } from './suajes/create-suaje/create-suaje.component';
import { ReadSuajeComponent } from './suajes/read-suaje/read-suaje.component';
import { UpdateSuajeComponent } from './suajes/update-suaje/update-suaje.component';
import { DisplaySuajeComponent } from './suajes/display-suaje/display-suaje.component';

// Menu : Machine
import { CreateMachineComponent } from './machines/create-machine/create-machine.component';
import { ReadMachineComponent } from './machines/read-machine/read-machine.component';
import { UpdateMachineComponent } from './machines/update-machine/update-machine.component';
import { DisplayMachineComponent } from './machines/display-machine/display-machine.component';

// Menu : Student
import { CreateStudentComponent } from './students/create-student/create-student.component';
import { UpdateStudentComponent } from './students/update-student/update-student.component';
import { ReadStudentComponent } from './students/read-student/read-student.component';
import { DisplayStudentComponent } from './students/display-student/display-student.component';

// Menu : parent
import { CreateParentComponent } from './parents/create-parent/create-parent.component';
import { UpdateParentComponent } from './parents/update-parent/update-parent.component';
import { ReadParentComponent } from './parents/read-parent/read-parent.component';
import { DisplayParentComponent } from './parents/display-parent/display-parent.component';
// Menu :  Teacher
import { CreateTeacherComponent } from './teacher/create-teacher/create-teacher.component';
import { UpdateTeacherComponent } from './teacher/update-teacher/update-teacher.component';
import { ReadTeacherComponent } from './teacher/read-teacher/read-teacher.component';
import { DisplayTeacherComponent } from './teacher/display-teacher/display-teacher.component';
// SubMenu : Theme
import { ThemeComponent } from './theme/theme.component';


import { ReadExpirationSupplierComponent } from './supplierBills/read-expiration-supplier/read-expiration-supplier.component';
import { ReadExpirationComponent } from './customerBills/read-expiration/read-expiration.component';
import { TransactionReportComponent } from './customers/transaction-report/transaction-report.component';
import { TransactionReportSupplierComponent } from './suppliers/transaction-report-supplier/transaction-report-supplier.component';
import { CertificateComponent } from './remissions/certificate/certificate.component';

//Reports
import { RentabilityReportComponent } from './reports/rentability-report/rentability-report.component';
import { YearlyReportComponent } from './reports/yearly-report/yearly-report.component';
import { ReadStockCostsComponent } from './stock/read-stock-costs/read-stock-costs.component';
import { CrudAutoComponent } from './auto/crud-auto/crud-auto.component';

//Sudo
import { SuperadminComponent } from './sudo/superadmin/superadmin.component';

export const RoutesDefinition: Routes = [
  { path: 'login', component: LoginPageComponent },
  { path: 'superadmin', component: SuperadminComponent },
  /* { path: 'register', component: RegisterComponent }, */
  { path: 'add_department', component: CreateDepartmentComponent },
  { path: 'departments', component: ReadDepartmentComponent },
  { path: 'edt_department/:id', component: UpdateDepartmentComponent },
  { path: 'vw_department/:id', component: DisplayDepartmentComponent },
  { path: 'add_employee', component: CreateEmployeeComponent },
  { path: 'employees', component: ReadEmployeeComponent },
  { path: 'edt_employee/:id', component: UpdateEmployeeComponent },
  { path: 'vw_employee/:id', component: DisplayEmployeeComponent },
  { path: 'roles_jobs', component: RolesjobsComponent, children: [
    { path: 'add_job', component: CreateJobComponent, outlet: 'tab_job' },
    { path: 'jobs', component: ReadJobComponent, outlet: 'tab_job' },
    { path: 'edt_job/:id', component: UpdateJobComponent, outlet: 'tab_job' },
    { path: 'vw_job/:id', component: DisplayJobComponent, outlet: 'tab_job' },
    { path: 'add_role', component: CreateRoleComponent, outlet: 'tab_role' },
    { path: 'roles', component: ReadRoleComponent, outlet: 'tab_role' },
    { path: 'edt_role/:id', component: UpdateRoleComponent, outlet: 'tab_role' },
    { path: 'vw_role/:id', component: DisplayRoleComponent, outlet: 'tab_role' }
  ] },
  { path: 'add_activity', component: CreateActivityComponent},
  { path: 'activities', component: ReadActivityComponent },
  { path: 'edt_activity/:id', component: UpdateActivityComponent},
  { path: 'vw_activity/:id', component: DisplayActivityComponent},
  { path: 'add_activity_class', component: CreateActivityClassificationComponent},
  { path: 'activity_class', component: ReadActivityClassificationComponent},
  { path: 'edt_activity_class/:id', component: UpdateActivityClassificationComponent},
  { path: 'add_work_shift', component: CreateWorkShiftComponent },
  { path: 'work_shifts', component: ReadWorkShiftComponent },
  { path: 'edt_work_shift/:id', component: UpdateWorkShiftComponent },
  { path: 'vw_work_shift/:id', component: DisplayWorkShiftComponent },
  { path: 'add_group', component: CreateGroupComponent },
  { path: 'groups', component: ReadGroupComponent },
  { path: 'edt_group/:id', component: UpdateGroupComponent },
  { path: 'vw_group/:id', component: DisplayGroupComponent },
  { path: 'add_user', component: CreateUserComponent },
  { path: 'users', component: ReadUserComponent },
  { path: 'edt_user/:id', component: UpdateUserComponent },
  { path: 'vw_user/:id', component: DisplayUserComponent },
  { path: 'permissions', component: DisplayPermissionComponent },
  { path: 'specialPermissions/:groupId', component: SpecialPermissionsComponent },
  { path: 'catalogs_settings/:tab', component: SettingsComponent },
  { path: 'add_check_clock', component: CreateCheckClockComponent },
  { path: 'check_clock', component: ReadCheckClockComponent },
  { path: 'vw_check_clock/:id', component: DisplayCheckClockComponent, children: [
    { path: 'registered_employees', component: ReadRegisteredEmployeesComponent, outlet: 'tab_registered_employees' },
    { path: 'add_unregistered/:folio', component: CreateUnregisteredEmployeeComponent, outlet: 'tab_unregistered_employees' },
    { path: 'unregistered_employees', component: ReadUnregisteredEmployeesComponent, outlet: 'tab_unregistered_employees' }
  ] },
  { path: 'add_supervisor_report', component: CreateSupervisorReportComponent },
  { path: 'supervisor_reports', component: ReadSupervisorReportComponent },
  { path: 'edt_supervisor_report/:id', component: UpdateSupervisorReportComponent },
  { path: 'vw_supervisor_report/:id', component: DisplaySupervisorReportComponent },
  { path: 'add_carrier_report', component: CreateCarrierReportComponent },
  { path: 'carrier_reports', component: ReadCarrierReportComponent },
  { path: 'edt_carrier_report/:id', component: UpdateCarrierReportComponent },
  { path: 'vw_carrier_report/:id', component: DisplayCarrierReportComponent },
  { path: 'add_prompter_report', component: CreatePrompterReportComponent },
  { path: 'prompter_reports', component: ReadPrompterReportComponent },
  { path: 'edt_prompter_report/:id', component: UpdatePrompterReportComponent },
  { path: 'vw_prompter_report/:id', component: DisplayPrompterReportComponent },
  { path: 'add_securityReport', component: CreateSecurityReportComponent },
  { path: 'securityReport', component: ReadSecurityReportComponent },
  { path: 'edt_securityReport/:id', component: UpdateSecurityReportComponent },
  { path: 'vw_securityReport/:id', component: DisplaySecurityReportComponent },
  { path: 'add_newPrompterReport', component: CreateNewPrompterReportComponent },
  { path: 'newPrompterReport', component: ReadNewPrompterReportComponent },
  { path: 'edt_newPrompterReport/:id', component: UpdateNewPrompterReportComponent },
  { path: 'vw_newPrompterReport/:id', component: DisplayNewPrompterReportComponent },
  { path: 'add_overtime', component: CreateOvertimeComponent },
  { path: 'overtimes', component: ReadOvertimeComponent },
  { path: 'edt_overtime/:id', component: UpdateOvertimeComponent },
  { path: 'vw_overtime/:id', component: DisplayOvertimeComponent },
  { path: 'assistance_report', component: DisplayAssistanceReportComponent },
  { path: 'assistance', component: DisplayAssistanceComponent },
  { path: 'payroll_estimate', component: DisplayPayrollEstimateComponent },
  { path: 'add_loan', component: CreateLoanComponent },
  { path: 'loans', component: ReadLoanComponent },
  { path: 'edt_loan/:id', component: UpdateLoanComponent },
  { path: 'vw_loan/:id', component: DisplayLoanComponent },
  { path: 'add_customer', component: CreateCustomerComponent },
  { path: 'customers', component: ReadCustomerComponent },
  { path: 'customersTransactionReport', component: TransactionReportComponent },
  { path: 'edt_customer/:id', component: UpdateCustomerComponent },
  { path: 'vw_customer/:id', data: { customerOrSupplier: 'customerId' }, component: DisplayCustomerComponent, children: [
    { path: 'add_address', component: CreateAddressComponent },
    { path: 'addresses', component: ReadAddressComponent },
    { path: 'edt_address/:id', component: UpdateAddressComponent },
    { path: 'vw_address/:id', component: DisplayAddressComponent },
    { path: 'add_fiscalData', component: CreateFiscalDataComponent },
    { path: 'fiscalData', component: ReadFiscalDataComponent },
    { path: 'edt_fiscalData/:id', component: UpdateFiscalDataComponent },
    { path: 'vw_fiscalData/:id', component: DisplayFiscalDataComponent },
    { path: 'add_keyPerson', component: CreateKeyPersonsComponent },
    { path: 'keyPersons', component: ReadKeyPersonsComponent },
    { path: 'edt_keyPerson/:id', component: UpdateKeyPersonsComponent },
    { path: 'vw_keyPerson/:id', component: DisplayKeyPersonsComponent }
  ] },
  { path: 'add_supplier', component: CreateSupplierComponent},
  { path: 'suppliers', component: ReadSupplierComponent},
  { path: 'suppliersTransactionReport', component: TransactionReportSupplierComponent},
  { path: 'edt_supplier/:id', component: UpdateSupplierComponent},
  { path: 'vw_supplier/:id', data: { customerOrSupplier: 'supplierId' }, component: DisplaySupplierComponent, children: [
    { path: 'add_address', component: CreateAddressComponent },
    { path: 'addresses', component: ReadAddressComponent },
    { path: 'edt_address/:id', component: UpdateAddressComponent },
    { path: 'vw_address/:id', component: DisplayAddressComponent },
    { path: 'add_fiscalData', component: CreateFiscalDataComponent },
    { path: 'fiscalData', component: ReadFiscalDataComponent },
    { path: 'edt_fiscalData/:id', component: UpdateFiscalDataComponent },
    { path: 'vw_fiscalData/:id', component: DisplayFiscalDataComponent },
    { path: 'add_keyPerson', component: CreateKeyPersonsComponent },
    { path: 'keyPersons', component: ReadKeyPersonsComponent },
    { path: 'edt_keyPerson/:id', component: UpdateKeyPersonsComponent },
    { path: 'vw_keyPerson/:id', component: DisplayKeyPersonsComponent }
  ] },
  { path: 'add_production_order/:customerId', component: CreateProductionOrderComponent },
  { path: 'production_orders', component: ReadProductionOrderComponent },
  { path: 'edt_production_order/:id/:customerId', component: UpdateProductionOrderComponent },
  { path: 'vw_production_order/:id', component: DisplayProductionOrderComponent },
  { path: 'odpPriority', component: OdpPriorityComponent },
  { path: 'odpLiteSearch', component: OdpLiteSearchComponent },
  { path: 'addsub', component: CreateSubsidiaryComponent },
  { path: 'sub', component: ReadSubsidiaryComponent },
  { path: 'edtsub/:id', component: UpdateSubsidiaryComponent },
  { path: 'ship', component: ReadShipComponent },
  { path: 'edit_ship/:id', component: UpdateShipComponent },
  { path: 'new_ship', component: CreateShipComponent },
  { path: 'unit', component: ReadUnitComponent },
  { path: 'edit_unit/:id', component: UpdateUnitComponent },
  { path: 'new_unit', component: CreateUnitComponent },
  { path: 'bank', component: ReadBankComponent },
  { path: 'edit_bank/:id', component: UpdateBankComponent },
  { path: 'vw_bank/:id', component: DisplayBankComponent },
  { path: 'new_bank', component: CreateBankComponent },
  { path: 'in_and_out', component: ReadInAndOutComponent },
  { path: 'edit_in_and_out/:id', component: UpdateInAndOutComponent },
  { path: 'new_in_and_out', component: CreateInAndOutComponent },
  { path: 'warehouse', component: ReadWarehouseComponent },
  { path: 'new_warehouse', component: CreateWarehouseComponent },
  { path: 'edit_warehouse/:id', component: UpdateWarehouseComponent },
  { path: 'all_tran', component: ReadAllTranComponent },
  { path: 'in_tran', component: ReadInTranComponent },
  { path: 'new_in_tran/:idWare', component: CreateInTranComponent },
  { path: 'out_tran', component: ReadOutTranComponent },
  { path: 'new_out_tran/:idWare', component: CreateOutTranComponent },
  { path: 'vw_tran/:idTran', component: DisplayTranComponent },
  { path: 'stock_pieces', component: ReadStockPiecesComponent },
  { path: 'stock_costs', component: ReadStockCostsComponent },
  { path: 'stockMinimal', component: StockMinimalComponent },
  { path: 'costs', component: ReadConstantCostsComponent },
  { path: 'new_cost', component: CreateConstantCostsComponent },
  { path: 'edit_cost/:id', component: UpdateConstantCostsComponent },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////Products
  { path: 'prType', component: ReadPrTypeComponent },
  { path: 'edit_prType/:id', component: UpdatePrTypeComponent },
  { path: 'new_prType', component: CreatePrTypeComponent },
  { path: 'prTypeC', component: ReadPrCTypeComponent },
  { path: 'edit_prTypeC/:id', component: UpdatePrCTypeComponent },
  { path: 'new_prTypeC', component: CreatePrCTypeComponent },
  { path: 'prVnta', component: ReadPrVntaComponent },
  { path: 'edit_prVnta/:id', component: UpdatePrVntaComponent },
  { path: 'new_prVnta', component: CreatePrVntaComponent },
  { path: 'vw_prVnta/:id', component: DisplayPrVntaComponent },
  { path: 'prCmpa', component: ReadPrCmpaComponent },
  { path: 'edit_prCmpa/:id', component: UpdatePrCmpaComponent },
  { path: 'new_prCmpa', component: CreatePrCmpaComponent },
  { path: 'vw_prCmpa/:id', component: DisplayPrCmpaComponent },
  { path: 'prClient', component: ReadPrClientComponent },
  { path: 'edit_prClient/:id', component: UpdatePrClientComponent },
  { path: 'new_prClient', component: CreatePrClientComponent },
  { path: 'vw_prClient/:id', component: DisplayPrClientComponent },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////Purchase order / request
  { path: 'purchase_order', component: ReadPurchaseOrderComponent },
  { path: 'edit_purchase_order/:id', component: UpdatePurchaseOrderComponent },
  { path: 'new_purchase_order/:idSup/:idReq', component: CreatePurchaseOrderComponent },
  { path: 'vw_purchase_order/:id/:from', component: DisplayPurchaseOrderComponent },
  { path: 'purchaseReport', component: PurchaseReportComponent },
  { path: 'purchase_request', component: ReadPurchaseRequestComponent },
  { path: 'add_purchase_request', component: CreatePurchaseRequestComponent },
  { path: 'vw_purchase_request/:id', component: DisplayPurchaseRequestComponent },
  { path: 'edit_purchase_request/:id', component: UpdatePurchaseRequestComponent },
  { path: 'order_purchase_request', component: OrderPurchaseRequestComponent },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////LiftOrder
  { path: 'liftOrder', component: ReadLiftOrderComponent },
  { path: 'edit_liftOrder/:id/:customerId', component: UpdateLiftOrderComponent },
  { path: 'new_liftOrder/:customerId', component: CreateLiftOrderComponent },
  { path: 'vw_liftOrder/:id', component: DisplayLiftOrderComponent },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////Supplier & Customer Bills
  { path: 'supplierBill', component: ReadSupplierBillComponent },
  { path: 'supplierBillExpiration', component: ReadExpirationSupplierComponent },
  { path: 'edit_supplierBill/:id/:fiscalDataId/:supplierId', component: UpdateSupplierBillComponent },
  { path: 'new_supplierBill/:fiscalDataId/:supplierId', component: CreateSupplierBillComponent },
  { path: 'vw_supplierBill/:id', component: DisplaySupplierBillComponent },
  { path: 'customerBill', component: ReadCustomerBillComponent },
  { path: 'customerBillExpiration', component: ReadExpirationComponent },
  { path: 'edit_customerBill/:id/:fiscalDataId/:customerId', component: UpdateCustomerBillComponent },
  { path: 'new_customerBill/:fiscalDataId/:customerId', component: CreateCustomerBillComponent },
  { path: 'vw_customerBill/:id', component: DisplayCustomerBillComponent },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////Income & Outcome
  { path: 'income', component: ReadIncomeComponent },
  { path: 'edit_income/:id/:fiscalDataId/:customerId', component: UpdateIncomeComponent },
  { path: 'new_income/:fiscalDataId/:customerId', component: CreateIncomeComponent },
  { path: 'vw_income/:id', component: DisplayIncomeComponent },
  { path: 'outcome', component: ReadOutcomeComponent },
  { path: 'edit_outcome/:id/:fiscalDataId/:supplierId', component: UpdateOutcomeComponent },
  { path: 'new_outcome/:fiscalDataId/:supplierId', component: CreateOutcomeComponent },
  { path: 'vw_outcome/:id', component: DisplayOutcomeComponent },
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////Reports
  //{ path: 'billReport', component: BillReportComponent },
  { path: 'billReportDetail', component: BillReportDetailComponent },
  //{ path: 'rentabilityReport', component: RentabilityReportComponent },
  { path: 'yearlyReport', component: YearlyReportComponent },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////Remission
  { path: 'remission', component: ReadRemissionComponent },
  { path: 'edit_remission/:id/:customerId', component: UpdateRemissionComponent },
  { path: 'remissionCertificate/:id', component: CertificateComponent },
  { path: 'new_remission/:customerId', component: CreateRemissionComponent },
  { path: 'vw_remission/:id', component: DisplayRemissionComponent },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////Suaje
  { path: 'suaje', component: ReadSuajeComponent },
  { path: 'edit_suaje/:id', component: UpdateSuajeComponent },
  { path: 'new_suaje', component: CreateSuajeComponent },
  { path: 'vw_suaje/:id', component: DisplaySuajeComponent },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////Machine
  { path: 'machine', component: ReadMachineComponent },
  { path: 'edit_machine/:id', component: UpdateMachineComponent },
  { path: 'new_machine', component: CreateMachineComponent },
  { path: 'vw_machine/:id', component: DisplayMachineComponent },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////Company
  { path: 'company', component: ViewCompanyComponent },
  { path: 'edit_company', component: UpdateCompanyComponent },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////Quot
  { path: 'quot', component: ReadQuotComponent },
  { path: 'edit_quot/:id', component: UpdateQuotComponent },
  { path: 'new_quot/:idPrVnta', component: CreateQuotComponent },
  { path: 'vw_quot/:id', component: DisplayQuotComponent },
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////Auto
  { path: 'crudAuto', component: CrudAutoComponent },

  { path: 'rentability', component: RentabilityReportComponent },

  { path: 'documents', component: DisplayDocumentsTypesComponent },
  { path: 'add_document', component: CreateDocumentsTypesComponent },
  { path: 'edit_document/:id', component: CreateDocumentsTypesComponent },

  { path: 'student', component: ReadStudentComponent },
  { path: 'edit_student/:id', component: UpdateStudentComponent },
  { path: 'vw_student/:id', component: DisplayStudentComponent },
  { path: 'new_student', component: CreateStudentComponent },

  { path: 'parent', component: ReadParentComponent },
  { path: 'edit_parent/:id', component: UpdateParentComponent },
  { path: 'vw_parent/:id', component: DisplayParentComponent },
  { path: 'new_parent', component: CreateParentComponent },
  
  { path: 'teacher', component: ReadTeacherComponent },
  { path: 'edit_teacher/:id', component: UpdateTeacherComponent },
  { path: 'vw_teacher/:id', component: DisplayTeacherComponent },
  { path: 'new_teacher', component: CreateTeacherComponent },
  { path: 'theme', component: ThemeComponent },
  
  { path: '**', component: HomeComponent },
];
